import React from "react";
import _ from "lodash";
import ModaArticoliAdvancedFiltersModal from "../../moda/ModaArticoliAdvancedFiltersModal";
import InputTendinaCategoria from "../elementiPagina/InputTendinaCategoria";
import CategorieWebSub from "../moduliArticolo/CategorieWebSub";

const buildLegacyCategoryTree = (categories = []) => {
  const nodesById = new Map();
  const parentById = new Map();
  (Array.isArray(categories) ? categories : []).forEach((category) => {
    const value = category?.external_id ?? category?.externalCategoryId;
    if (value === undefined || value === null || value === "") return;
    const id = String(value);
    nodesById.set(id, {
      value: id,
      label: `${id} - ${category?.label ?? category?.name ?? id}`,
      children: [],
    });
    const parent = category?.parent_external_id;
    parentById.set(
      id,
      parent === undefined || parent === null ? "" : String(parent),
    );
  });
  const roots = [];
  nodesById.forEach((node, id) => {
    const parent = nodesById.get(parentById.get(id));
    if (parent && parent !== node) parent.children.push(node);
    else roots.push(node);
  });
  return roots;
};

const prepareLegacyCategoryTree = (nodes = [], selected = []) => {
  const selectedValues = new Set(selected.map(String));
  return _.cloneDeep(Array.isArray(nodes) ? nodes : []).map(function mark(node) {
    const children = Array.isArray(node.children) ? node.children.map(mark) : [];
    return {
      ...node,
      checked: selectedValues.has(String(node.value)),
      ...(children.length ? { children } : {}),
    };
  });
};

const buildLegacyDefaultOptions = (nodes = [], selected = []) => {
  const selectedValues = new Set(selected.map(String));
  const options = [];
  const visit = (items) =>
    (Array.isArray(items) ? items : []).forEach((item) => {
      if (selectedValues.has(String(item.value))) {
        options.push({ value: item.value, label: item.label });
      }
      visit(item.children);
    });
  visit(nodes);
  return ["", ...options];
};

function Categorie({
  prodottoTemp,
  view,
  onViewChange,
  siteFields,
  siteCategories,
  datiUlterioriStandard,
  inputClasses,
  buttonClassesWhite,
  mappingSaving,
  mappingFeedback,
  onOpenMapping,
  onFiltersChange,
  initialFilters,
  baselineFilters,
  lookupOptions,
  initialMappingTab,
  mappingRequirements,
  onResolveExistingMappings,
  onApplyExistingMapping,
  onChangeDefaultCategory,
  onChangeSiteCategories,
  getValidationError,
}) {
  const renderLegacySelection = (siteKey) => {
    const config = siteFields[siteKey];
    const selectedCategories = Array.isArray(
      prodottoTemp?.[config.categoriesField],
    )
      ? prodottoTemp[config.categoriesField].map(String)
      : [];
    const siteTree = buildLegacyCategoryTree(siteCategories[siteKey]);
    const fallbackTree =
      siteKey === "VIG" && Array.isArray(datiUlterioriStandard?.categorieWeb)
        ? datiUlterioriStandard.categorieWeb
        : [];
    const treeData = prepareLegacyCategoryTree(
      siteTree.length ? siteTree : fallbackTree,
      selectedCategories,
    );
    const defaultOptions = buildLegacyDefaultOptions(
      treeData,
      selectedCategories,
    );
    const validationError = getValidationError(prodottoTemp, siteKey);

    return (
      <div className="modificaProdottiCategorieLegacy">
        <div className="mb3">
          <h3 className="mt0 mb1">Categorie web {config.label}</h3>
          <p className="ma0 f6 colScrittaDef-20">
            Selezione manuale indipendente dalle regole di mapping.
          </p>
        </div>
        <InputTendinaCategoria
          objOpzioni={defaultOptions}
          datoValue={prodottoTemp?.[config.defaultField] ?? ""}
          inputLabel={`Categoria predefinita ${config.label}`}
          datoName={config.defaultField}
          datoId={`categoria-predefinita-${siteKey}`}
          datoOnChange={onChangeDefaultCategory}
          datoClass={inputClasses}
        />
        {validationError && (
          <p className="dark-red mt2 mb3">{validationError}</p>
        )}
        {treeData.length ? (
          <CategorieWebSub
            data={treeData}
            categorie={selectedCategories}
            onChange={(currentNode, selectedNodes) =>
              onChangeSiteCategories(siteKey, selectedNodes)
            }
          />
        ) : (
          <p className="f6 colScrittaDef-20">
            Nessuna categoria disponibile per {config.label}.
          </p>
        )}
      </div>
    );
  };

  return (
    <section className="modificaProdottiPagina modificaProdottiCategoriePagina pa2">
      <nav className="modificaProdottiSubNav flex flex-wrap flex-shrink-0">
        {[
          ["mapping", "Mapping"],
          ["legacy-vig", "Specifica categorie Viglietti"],
          ["legacy-bot", "Specifica categorie Bottero"],
        ].map(([viewId, label]) => (
          <button
            key={viewId}
            type="button"
            className={
              view === viewId
                ? "modificaProdottiSubNavItem modificaProdottiSubNavItem--active"
                : "modificaProdottiSubNavItem"
            }
            onClick={() => onViewChange(viewId)}
            aria-current={view === viewId ? "page" : undefined}
          >
            {label}
          </button>
        ))}
      </nav>

      <div
        className={`modificaProdottiCategorieBody ${
          view === "mapping" ? "modificaProdottiCategorieBody--mapping" : ""
        }`}
      >
        {view === "mapping" && (
          <>
            <div className="flex items-center justify-between mb2 flex-shrink-0">
              <h3 className="ma0">Mappatura categorie</h3>
              <button
                type="button"
                className={buttonClassesWhite}
                onClick={onOpenMapping}
                disabled={mappingSaving}
              >
                Nuova map
              </button>
            </div>
            {mappingFeedback && (
              <div className="mb2 pa2 br2 ba bordoColAlt f6 flex-shrink-0">
                {mappingFeedback}
              </div>
            )}
            <div className="modificaProdottiCategorieMapping">
              <ModaArticoliAdvancedFiltersModal
                key={
                  "category-mapping-embedded-" +
                  (prodottoTemp?._id ?? prodottoTemp?.codiceVS ?? "__NO_ID__")
                }
                embedded
                open
                onClose={() => onViewChange("mapping")}
                onFiltersChange={onFiltersChange}
                initialFilters={initialFilters}
                baselineFilters={baselineFilters}
                lookupOptions={lookupOptions}
                datiUlterioriStandard={datiUlterioriStandard}
                temaColori="rootTema"
                categoryMappingMode
                categoryMappingProductMode
                categoryMappingTitle="Dati per il mapping categorie"
                initialCategoryMappingTab={initialMappingTab}
                categoryMappingRequirements={mappingRequirements}
                onResolveExistingMappings={onResolveExistingMappings}
                onApplyExistingMapping={onApplyExistingMapping}
              />
            </div>
          </>
        )}
        {view === "legacy-vig" && renderLegacySelection("VIG")}
        {view === "legacy-bot" && renderLegacySelection("BOT")}
      </div>
    </section>
  );
}

export default Categorie;
